// 카드사 아이콘 import
import AmericanExpressIcon from "@/src/assets/icons/Property 1=amex.svg"
import BCIcon from "@/src/assets/icons/Property 1=bc.svg"
import DinersClubIcon from "@/src/assets/icons/Property 1=diners.svg"
import HanaIcon from "@/src/assets/icons/Property 1=hana.svg"
import HyundaiIcon from "@/src/assets/icons/Property 1=hyundai.svg"
import JcbIcon from "@/src/assets/icons/Property 1=jcb.svg"
import KBIcon from "@/src/assets/icons/Property 1=kb.svg"
import LotteIcon from "@/src/assets/icons/Property 1=lotte.svg"
import MasterIcon from "@/src/assets/icons/Property 1=master.svg"
import NHIcon from "@/src/assets/icons/Property 1=nh.svg"
import SamsungIcon from "@/src/assets/icons/Property 1=samsung.svg"
import ShinhanIcon from "@/src/assets/icons/Property 1=shinhan.svg"
import UnionPayIcon from "@/src/assets/icons/Property 1=union.svg"
import VisaIcon from "@/src/assets/icons/Property 1=visa.svg"
import WooriIcon from "@/src/assets/icons/Property 1=woori.svg"

// binlookup 제거 - CORS 문제로 인해 클라이언트 사이드 패턴 매칭만 사용

// 카드 아이콘 매핑
const CARD_ICON_MAP: Record<string, string | null> = {
  visa: VisaIcon,
  mastercard: MasterIcon,
  "american express": AmericanExpressIcon,
  "american-express": AmericanExpressIcon,
  amex: AmericanExpressIcon,
  jcb: JcbIcon,
  "diners club": DinersClubIcon,
  "diners-club": DinersClubIcon,
  diners: DinersClubIcon,
  unionpay: UnionPayIcon,
  union: UnionPayIcon,
}

// 한국 카드사 매핑 (은행명이나 브랜드명으로)
const KOREAN_BANK_CARD_MAP: Record<string, { type: string; displayName: string; icon: string | null }> = {
  "현대": {type: "hyundai", displayName: "현대카드", icon: HyundaiIcon},
  "hyundai": {type: "hyundai", displayName: "현대카드", icon: HyundaiIcon},
  "롯데": {type: "lotte", displayName: "롯데카드", icon: LotteIcon},
  "lotte": {type: "lotte", displayName: "롯데카드", icon: LotteIcon},
  "삼성": {type: "samsung", displayName: "삼성카드", icon: SamsungIcon},
  "samsung": {type: "samsung", displayName: "삼성카드", icon: SamsungIcon},
  "신한": {type: "shinhan", displayName: "신한카드", icon: ShinhanIcon},
  "shinhan": {type: "shinhan", displayName: "신한카드", icon: ShinhanIcon},
  "kb": {type: "kb", displayName: "KB국민카드", icon: KBIcon},
  "국민": {type: "kb", displayName: "KB국민카드", icon: KBIcon},
  "kookmin": {type: "kb", displayName: "KB국민카드", icon: KBIcon},
  "하나": {type: "hana", displayName: "하나카드", icon: HanaIcon},
  "hana": {type: "hana", displayName: "하나카드", icon: HanaIcon},
  "우리": {type: "woori", displayName: "우리카드", icon: WooriIcon},
  "woori": {type: "woori", displayName: "우리카드", icon: WooriIcon},
  "농협": {type: "nh", displayName: "NH농협카드", icon: NHIcon},
  "nh": {type: "nh", displayName: "NH농협카드", icon: NHIcon},
  "nonghyup": {type: "nh", displayName: "NH농협카드", icon: NHIcon},
  "bc": {type: "bc", displayName: "BC카드", icon: BCIcon},
}

// 한국 카드사 BIN 매핑 (binlookup이 실패하거나 한국 카드를 제대로 인식하지 못할 경우를 위한 폴백)
const KOREAN_CARD_BINS: Array<{ pattern: RegExp; info: { type: string; displayName: string; icon: string | null } }> = [
  // 현대카드
  {
    pattern: /^(360[0-9]|361[0-9]|364[0-9]|365[0-9]|370200|374600|378300|378700|379000|401700|402000|402500|402800|403200|404500|404900|405600|415300|421200|433000|524800)/,
    info: KOREAN_BANK_CARD_MAP["hyundai"]
  },
  // 롯데카드
  {
    pattern: /^(356300|356500|356700|376[2-9]00|377900|404100|405400|405600|406100|455308|455309|527100|532900)/,
    info: KOREAN_BANK_CARD_MAP["lotte"]
  },
  // 삼성카드
  {
    pattern: /^(209300|356600|356700|376200|379[12]00|400900|404700|413200|413700|458100|509100)/,
    info: KOREAN_BANK_CARD_MAP["samsung"]
  },
  // 신한카드
  {
    pattern: /^(200000|205000|356[0-7]00|377100|377900|379900|400700|400900|402900|403900|457700|542800|941[0-9]00)/,
    info: KOREAN_BANK_CARD_MAP["shinhan"]
  },
  // KB국민카드
  {
    pattern: /^(222800|356400|356900|370300|374700|375100|376300|407400|411100|457700|542800|941[0-9]00)/,
    info: KOREAN_BANK_CARD_MAP["kb"]
  },
  // 하나카드
  {
    pattern: /^(356500|356700|357100|371000|374700|377900|379100|379900|400900|402100|402300|403800|407900|457600|950[0-5]00)/,
    info: KOREAN_BANK_CARD_MAP["hana"]
  },
  // 우리카드
  {
    pattern: /^(356[0-9]00|400600|401300|401500|402500|403000|403500|404700|405200|406100|408300|410100|412000|412900|436400|437100|452000|952[0-5]00)/,
    info: KOREAN_BANK_CARD_MAP["woori"]
  },
  // NH농협카드
  {
    pattern: /^(352[89]00|356[3-9]00|357100|407900|409200|432300|433000|949[0-5]00|941116)/,
    info: KOREAN_BANK_CARD_MAP["nh"]
  },
  // BC카드
  {pattern: /^(356[0-9]00|457700|542800|941[0-9]00|942[012]00)/, info: KOREAN_BANK_CARD_MAP["bc"]},
]

// 카드 타입 조회 함수 (클라이언트 사이드 패턴 매칭)
export const getCardTypeAsync = async (cardNumber: string) => {
  const cleanedNumber = cardNumber.replace(/\s+/g, "")

  // 카드 번호 패턴으로 카드 타입 추정
  // 국제 카드 브랜드 패턴 확인
  if (cleanedNumber.length >= 4) {
    // Visa: 4로 시작
    if (cleanedNumber.startsWith("4")) {
      return {
        type: "visa",
        icon: VisaIcon,
        displayName: "Visa",
      }
    }

    // Mastercard: 51-55 또는 2221-2720으로 시작
    if ((cleanedNumber.substring(0, 2) >= "51" && cleanedNumber.substring(0, 2) <= "55") ||
        (cleanedNumber.substring(0, 4) >= "2221" && cleanedNumber.substring(0, 4) <= "2720")) {
      return {
        type: "mastercard",
        icon: MasterIcon,
        displayName: "Mastercard",
      }
    }

    // American Express: 34 또는 37로 시작
    if (cleanedNumber.startsWith("34") || cleanedNumber.startsWith("37")) {
      return {
        type: "amex",
        icon: AmericanExpressIcon,
        displayName: "American Express",
      }
    }

    // JCB: 3528-3589로 시작
    if (cleanedNumber.substring(0, 4) >= "3528" && cleanedNumber.substring(0, 4) <= "3589") {
      return {
        type: "jcb",
        icon: JcbIcon,
        displayName: "JCB",
      }
    }

    // Diners Club: 36, 38, 또는 300-305로 시작
    if (cleanedNumber.startsWith("36") || cleanedNumber.startsWith("38") ||
        (cleanedNumber.substring(0, 3) >= "300" && cleanedNumber.substring(0, 3) <= "305")) {
      return {
        type: "diners",
        icon: DinersClubIcon,
        displayName: "Diners Club",
      }
    }

    // UnionPay: 62로 시작
    if (cleanedNumber.startsWith("62")) {
      return {
        type: "unionpay",
        icon: UnionPayIcon,
        displayName: "UnionPay",
      }
    }

    // 한국 카드 BIN 패턴 확인
    for (const binInfo of KOREAN_CARD_BINS) {
      if (binInfo.pattern.test(cleanedNumber)) {
        return binInfo.info
      }
    }
  }

  // 실패한 경우 기본값 반환
  return {
    type: "unknown",
    icon: null,
    displayName: "Unknown Card",
  }
}

